import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoices/${number | ':invoiceId'}/editInvoiced`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoices/:invoiceId/editInvoiced`;

export const URL = (jobId: number, invoiceId: number): RouteDefinition => `${baseRoute}/${jobId}/invoices/${invoiceId}/editInvoiced`;
